import { UserFeatureState } from '../../../@types/state-types'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { User } from '../../../@types/types'

export const initialState: UserFeatureState = {
  contingentCustomer: false,
  isProfessional: false,
  ssoId: undefined,
  phoneNumber: undefined,
}

const userSlice = createSlice({
  name: 'userFeature',
  initialState,
  reducers: {
    getUserSuccess(state, action: PayloadAction<{ user: User }>) {
      const { user } = action.payload
      state.contingentCustomer = user.contingentCustomer
      state.isProfessional = user.isProfessional
      state.ssoId = user.ssoId
      state.phoneNumber = user.contact?.phoneNumber
    },
  },
})
export const { getUserSuccess } = userSlice.actions
export default userSlice.reducer
